import { create } from 'zustand';
import { api } from '../services/api';

export const useAuthStore = create((set) => ({
  user: null,
  token: null,
  language: 'de',

  setLanguage: (lang) => {
    set({ language: lang });
    localStorage.setItem('language', lang);
  },

  login: async (email, password) => {
    const res = await api.post('/auth/login', { email, password });
    // Admin 2FA flow
    if (res.data.requires_2fa) {
      return { requires_2fa: true, email: res.data.email, message: res.data.message };
    }
    const { access_token, user } = res.data;
    localStorage.setItem('token', access_token);
    localStorage.setItem('user', JSON.stringify(user));
    set({ token: access_token, user });
    return { user };
  },

  verify2FA: async (email, code) => {
    const res = await api.post('/auth/verify-2fa', { email, code });
    const { access_token, user } = res.data;
    localStorage.setItem('token', access_token);
    localStorage.setItem('user', JSON.stringify(user));
    set({ token: access_token, user });
    return { user };
  },

  register: async (email, password, name, phone) => {
    const res = await api.post('/auth/register', { email, password, name, phone });
    // New flow: registration returns requires_verification
    if (res.data.requires_verification) {
      return { requires_verification: true, email: res.data.email };
    }
    // Fallback for already verified / Google users
    const { access_token, user } = res.data;
    localStorage.setItem('token', access_token);
    localStorage.setItem('user', JSON.stringify(user));
    set({ token: access_token, user });
    return { user };
  },

  verifyEmail: async (email, code) => {
    const res = await api.post('/auth/verify-email', { email, code });
    const { access_token, user } = res.data;
    localStorage.setItem('token', access_token);
    localStorage.setItem('user', JSON.stringify(user));
    set({ token: access_token, user });
    return { user };
  },

  resendCode: async (email) => {
    await api.post('/auth/resend-code', { email });
  },

  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    set({ token: null, user: null });
  },

  loadFromStorage: () => {
    const token = localStorage.getItem('token');
    const userStr = localStorage.getItem('user');
    const lang = localStorage.getItem('language');
    if (token && userStr) {
      set({ token, user: JSON.parse(userStr) });
    }
    if (lang) {
      set({ language: lang });
    }
  },
}));
